import { css } from '@emotion/core'
import { ExpanderHeader, colors } from '@fs/zion-ui'
import React from 'react'

// zion-ui's ExpanderHeader renders the <button> itself, so a heading passed to it as
// children is flattened into the button's accessible name and disappears from the heading
// outline. The ARIA accordion pattern puts the heading around the button instead, which
// means reproducing the heading type styles here rather than using H3.
const headingCss = css`
  color: ${colors.gray100};
  font-family: var(--font-families-body);
  font-weight: 600;
  line-height: 1.2;
  word-break: break-word;

  /* The browser's own button styles would otherwise override the heading type */
  button {
    font: inherit;
  }
`

const sizeCss = {
  H5: css`
    font-size: var(--text-size-c);
  `,
  H6: css`
    font-size: var(--text-size-b);
  `,
}

type ExpanderHeadingProps = Readonly<{
  children: React.ReactNode
  size?: 'H5' | 'H6'
}>

export default function ExpanderHeading({ children, size = 'H5' }: ExpanderHeadingProps) {
  return (
    <h3 css={[headingCss, sizeCss[size]]}>
      <ExpanderHeader>{children}</ExpanderHeader>
    </h3>
  )
}
